import React from 'react';
import { useAtom } from 'jotai';
import Header from './header';
import RuleForm from './editor/RuleForm';
import AlertRulesList from './list';
import { StyledDrawer } from './styled';
import { isCreateRuleFormOpenAtom, editingRuleAtom } from './atoms';

const AlertRulesDrawer = ({
  isOpen,
  closeDrawer,
}: {
  isOpen: boolean;
  closeDrawer: () => void;
}) => {
  const [isFormOpen, setIsFormOpen] = useAtom(isCreateRuleFormOpenAtom);
  const [editingRule, setEditingRule] = useAtom(editingRuleAtom);

  const handleCloseForm = () => {
    setIsFormOpen(false);
    setEditingRule(null);
  };

  const handleCloseDrawer = () => {
    handleCloseForm();
    closeDrawer();
  };

  const showForm = isFormOpen || editingRule !== null;

  return (
    <StyledDrawer
      open={isOpen}
      closeIcon={null}
      styles={{ wrapper: { width: 1280, maxWidth: '90vw' } }}
      onClose={handleCloseDrawer}
      keyboard
    >
      <Header closeDrawer={handleCloseDrawer} />

      {!showForm && isOpen ? <AlertRulesList isDrawerOpen={isOpen} /> : null}

      {showForm ? (
        <RuleForm onClose={handleCloseForm} initialValues={editingRule ?? undefined} />
      ) : null}
    </StyledDrawer>
  );
};

export default AlertRulesDrawer;
